import React from "react";
import {
  ChipField,
  Datagrid,
  DateField,
  List,
  useResourceContext,
  useTranslate,
  ReferenceArrayField,
  ReferenceField,
  SingleFieldList,
  TextField,
  Pagination,
  TextInput,
  DateInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
} from "react-admin";

import { UnitPriceField } from "../components/producer_summaries/unit_price_field";
import { csvExporter } from "../infrastructure/csvExporter";

const commonStyles = {
  dateInput: {
    minWidth: "180px",
  },
};

const OfferRequestsFilter = [
  <DateInput
    key="updated_at"
    source="updated_at"
    label="resources.offer_requests.fields.updated_at_filter"
    sx={commonStyles.dateInput}
  />,
  <TextInput key="annum_name" source="annum_name" />,
  <ReferenceInput
    key="prefecture_id"
    label="ui.offer_requests.prefecture"
    source="prefecture_id"
    reference="prefectures"
    filter={{ is_active: true }}
  >
    <SelectInput optionText="name" />
  </ReferenceInput>,
  <TextInput key="region_name" source="region_name" />,
  <TextInput key="brand_name" source="brand_name" />,
  <TextInput key="grade_name" source="grade_name" />,
  <NumberInput key="unit_price" source="unit_price" label="resources.offer_requests.fields.unit_price_filter" />,
  <ReferenceInput
    key="special_condition_id"
    source="special_condition_id"
    reference="special_conditions"
    filter={{ is_active: true }}
  >
    <SelectInput optionText="display_text" />
  </ReferenceInput>,
];

export const OfferRequestList = (props: any) => {
  const resource = useResourceContext();
  const translate = useTranslate();

  return (
    <List
      {...props}
      sort={{ field: "updated_at", order: "DESC" }}
      filters={OfferRequestsFilter}
      bulkActionButtons={false}
      exporter={csvExporter(resource, translate)}
      perPage={50}
      pagination={<Pagination rowsPerPageOptions={[5, 10, 25, 50]} />}
    >
      <Datagrid bulkActionButtons={false}>
        <DateField source="updated_at" locales={"ja"} showTime={false} />
        <ReferenceField source="annum_id" reference="annums" link={false} emptyText={translate("ui.value.not_set")}>
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          source="updated_by_organization.prefecture_id"
          reference="prefectures"
          link={false}
          sortBy="prefecture_id"
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="region_id" reference="regions" link={false} sortable={false}>
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="brand_id" reference="brands" link={false} sortBy="brand_name_kana">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="grade_id" reference="grades" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <UnitPriceField source="unit_price" />
        <ReferenceArrayField source="special_condition_ids" reference="special_conditions" sortable={false}>
          <SingleFieldList linkType={false}>
            <ChipField source="display_text" />
          </SingleFieldList>
        </ReferenceArrayField>
      </Datagrid>
    </List>
  );
};
